"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_REGEX = exports.NAMES_REGEX = void 0;
exports.NAMES_REGEX = "^(?![^\\-]+\\-[^\\-]+\\-)(?![^\\']+\\'[^\\']+\\')((([A-Za-zÀ-ÿ]+)([\\s\\-\\']?(?=[A-Za-zÀ-ÿ]))?))+$";
exports.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
